import {FormGridField} from "../../../../../utils/forms/components/FormGrid";
import _ from "lodash";
import * as Yup from "yup";

export const pigBoomFields = _.memoize(():FormGridField[] => [
    {
        name: "prize_parameters_group",
        fieldType: "group",
        fieldOptions: {
            id: "prizeParametersGroup",
            inputType: "group",
            label: "Prize Parameters"
        },
        formSpacing: false,
        columnClass: "col-12"
    },
    {
        name: "min_players",
        fieldType: "number",
        fieldOptions: {
            id: "minPlayers",
            placeholder: "Min. Players",
            inputType: "integer",
            label: "Min. Players"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "contribution",
        fieldType: "number",
        fieldOptions: {
            id: "contrib",
            placeholder: "Insert Contribution",
            inputType: "number",
            label: "Contribution",
            decimal: true
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .min(0.01, "Value must be >= 0,01.")
            .max(10, "Must be <= than 10")
    },
    {
        name: "start_percentage",
        fieldType: "number",
        fieldOptions: {
            id: "startPercentage",
            placeholder: "Start Percentage",
            inputType: "number",
            label: "Start Percentage"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(100, "Must be <= than 100")
    },
    {
        name: "prize_gold_value",
        fieldType: "number",
        fieldOptions: {
            id: "prizeGoldValue",
            placeholder: "Prize Gold Value",
            inputType: "number",
            label: "Prize Gold Value"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "prize_silver_value",
        fieldType: "number",
        fieldOptions: {
            id: "prizeSilverValue",
            placeholder: "Prize Silver Value",
            inputType: "number",
            label: "Prize Silver Value"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "prize_bronze_value",
        fieldType: "number",
        fieldOptions: {
            id: "prizeBronzeValue",
            placeholder: "Prize Bronze Value",
            inputType: "number",
            label: "Prize Bronze Value"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "prize_gold_frequency",
        fieldType: "number",
        fieldOptions: {
            id: "prizeGoldFrequency",
            placeholder: "Prize Gold Freq.",
            inputType: "number",
            label: "Prize Gold Freq."
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "prize_silver_frequency",
        fieldType: "number",
        fieldOptions: {
            id: "prizeSilverFrequency",
            placeholder: "Prize Silver Freq.",
            inputType: "number",
            label: "Prize Silver Freq."
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "prize_bronze_frequency",
        fieldType: "number",
        fieldOptions: {
            id: "prizeBronzeFrequency",
            placeholder: "Prize Bronze Freq.",
            inputType: "number",
            label: "Prize Bronze Freq."
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "time_parameters_group",
        fieldType: "group",
        fieldOptions: {
            id: "timeParametersGroup",
            inputType: "group",
            label: "Time Parameters"
        },
        formSpacing: false,
        columnClass: "col-12"
    },
    {
        name: "time_wait_video",
        fieldType: "number",
        fieldOptions: {
            id: "timeWaitVideo",
            placeholder: "Time Wait Video",
            inputType: "number",
            label: "Time Wait Video"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "pop_time",
        fieldType: "number",
        fieldOptions: {
            id: "popTime",
            placeholder: "Pop Time",
            inputType: "number",
            label: "Pop Time"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "min_pop_time",
        fieldType: "number",
        fieldOptions: {
            id: "minPopTime",
            placeholder: "Min Pop Time",
            inputType: "number",
            label: "Min Pop Time"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "time_eligible",
        fieldType: "number",
        fieldOptions: {
            id: "timeEligible",
            placeholder: "Time Eligible",
            inputType: "number",
            label: "Time Eligible"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Must be <= than 255")
            .integer("Must be an integer")
    },
    {
        name: "time_continue_eligible_bonus",
        fieldType: "number",
        fieldOptions: {
            id: "timeContinueEligibleBonus",
            placeholder: "Time Continue Eligible Bonus",
            inputType: "number",
            label: "Time Continue Eligible Bonus"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Must be <= than 255")
            .integer("Must be an integer")
    },
    {
        name: "time_continue_eligible_game",
        fieldType: "number",
        fieldOptions: {
            id: "timeContinueEligibleGame",
            placeholder: "Time Continue Eligible Game",
            inputType: "number",
            label: "Time Continue Eligible Game"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Must be <= than 255")
            .integer("Must be an integer")
    },
    {
        name: "time_continue_eligible_extra",
        fieldType: "number",
        fieldOptions: {
            id: "timeContinueEligibleExtra",
            placeholder: "Time Continue Eligible Extra",
            inputType: "number",
            label: "Time Continue Eligible Extra"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Must be <= than 255")
            .integer("Must be an integer")
    },
    {
        name: "show_eligible_bonus_icon",
        fieldType: "switch",
        fieldOptions: {
            id: "PigBoomShowEligibleBonusIcon",
            label: "Show Eligible Bonus Icon"
        },
        validation: Yup.string(),
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false
    },
    {
        name: "security_parameters_group",
        fieldType: "group",
        fieldOptions: {
            id: "securityParametersGroup",
            inputType: "group",
            label: "Security Parameters"
        },
        formSpacing: false,
        columnClass: "col-12"
    },
    {
        name: "weight_coin_in",
        fieldType: "number",
        fieldOptions: {
            id: "weightCoinIn",
            placeholder: "Weight Coin In",
            inputType: "number",
            label: "Weight Coin In"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "percentage_terminal",
        fieldType: "number",
        fieldOptions: {
            id: "percentageTerminal",
            placeholder: "Percentage Terminal",
            inputType: "number",
            label: "Percentage Terminal"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "weight_total_bonus_win",
        fieldType: "number",
        fieldOptions: {
            id: "weightTotalBonusWin",
            placeholder: "Weight Total Bonus Win",
            inputType: "number",
            label: "Weight Total Bonus Win"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "number_eligible_games",
        fieldType: "number",
        fieldOptions: {
            id: "numberEligibleGames",
            placeholder: "Number Eligible Games",
            inputType: "number",
            label: "Number Eligible Games"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "hunter_draw_no_win",
        fieldType: "number",
        fieldOptions: {
            id: "hunterDrawNoWin",
            placeholder: "Hunter Draw No Win",
            inputType: "number",
            label: "Hunter Draw No Win"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    }
])